// extracted by css-extract-rspack-plugin
export default {"menuLink":"menuLink__F9BzD","menuLink_active":"menuLink_active___0Dhw","theme_info":"theme_info__Dmd13","questionLink":"questionLink__xmUKx"};